module.exports = __webpack_public_path__ + "static/img/coconutpineapple_th.0032779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/coconutpineapple_th.png
// module id = 1AXl
// module chunks = 0